import { render, staticRenderFns } from "./WebsiteGallery.vue?vue&type=template&id=29aa7c35&scoped=true&"
import script from "./WebsiteGallery.vue?vue&type=script&lang=js&"
export * from "./WebsiteGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29aa7c35",
  null
  
)

export default component.exports